import pawsWithPacksWebPng from './paws-with-packs-original.png';
import pawsWithPacksWebP from './paws-with-packs.webp';
import pawsWithPacksJpg from './paws-with-packs.jpg';

export const pawsWithPacks = [
  pawsWithPacksWebP,
  pawsWithPacksJpg,
  pawsWithPacksWebPng,
];
